export default __webpack_public_path__ + "static/media/preloader.ea356991.svg";